<div class="flex flex-col h-full w-full bg-[#FFFFFF] gap-6 pb-6">
  <app-quality-stepper (changeDrivenEvent)="stepperEvent($event)" [isCheckView]="true" [previousStepAllowed]="true"
                       [selectedStep]="0" class="w-full flex-shrink-0"></app-quality-stepper>

    <!-- Selection Lists -->
    <div class="flex flex-row flex-1 w-full gap-6 px-6 overflow-hidden">
      <!-- Available rules -->
      <div class="flex flex-col h-full w-1/2 gap-3 py-6 border-bic-gray-200 border rounded-lg overflow-hidden">
        <!-- Header -->
        <div class="flex flex-row w-full gap-4 px-6 justify-between items-center flex-shrink-0">
          <p class="text-gray text-sm font-medium">Verfügbare Prüfregeln:</p>
          <div class="flex flex-row w-fit gap-4">
            <app-bic-filter (filtersChange)="filtersChange($event)"
                            [filtersConfig]="filtersConfig"></app-bic-filter>
            <bic-button (click)="addOrRemoveFilteredRulesFromSelectedRules()"
                        [tooltip]="filterRules.length == 0 ? 'Alle abwählen' : 'Alle auswählen'"
                        buttonType="white">Alle
            </bic-button>
          </div>
        </div>

        <!-- Rule picker list -->
        <div #availableRulesList="cdkDropList"
             (cdkDropListDropped)="drop($event)"
             [cdkDropListConnectedTo]="selectedRulesList"
             [cdkDropListData]="filterRules"
             cdkDropList
             class="flex flex-col flex-grow min-h-0 w-full overflow-y-auto gap-3 py-1 px-6"
             id="availableRulesList">
          @if (!rulesLoaded) {
            <div class="flex h-full justify-center items-center">
              <div class="flex flex-row items-center gap-2">
                <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
                <span class="text-sm font-medium text-gray-500">Prüfregeln werden geladen...</span>
              </div>
            </div>
          } @else if (filteredRules.length == 0) {
            <div class="flex h-full justify-center items-center">Alle Prüfregeln ausgewählt</div>
          } @else {
            @for (rule of filterRules; track rule.id) {
              <div cdkDrag
                   class="flex flex-row shadow-full w-full rounded-lg justify-between items-center hover:cursor-grab p-4 flex-shrink-0">
                <div class="flex flex-row justify-start items-center gap-4 min-w-0">
                  @if (!isRuleSelected(rule)) {
                    <button (click)="addRuleToSelectedRules(rule)" class="flex-shrink-0">
                      <fa-icon [icon]="faPlusCircle" class="text-green"></fa-icon>
                    </button>
                  } @else {
                    <button (click)="removeRuleFromSelectedRules(rule)" class="flex-shrink-0" mat-icon-button>
                      <fa-icon [icon]="faCircleXmark" class="text-yellow"></fa-icon>
                    </button>
                  }
                  <div class="font-medium text-gray-700 text-sm truncate">{{ rule.name }}</div>
                </div>
                <div class="flex flex-row justify-end items-center gap-4 flex-shrink-0">
                  <div class="flex flex-row justify-end items-center gap-2">
                    @for (type of rule.docTypes; track type.name) {
                      <bic-badge
                        [tooltip]="type.name === 'LV' ? 'Leistungsverzeichnis' : type.name === 'IFC' ? 'Industry Foundation Classes' : type.name === 'RB' ? 'Raumbuch' : ''">
                        {{ type.name }}
                      </bic-badge>
                    }
                  </div>
                  <div [tooltipDirection]="'right'" [tooltipSubtext]="getRuleInfoTooltip(rule)"
                       [tooltip]="rule.name" [tooltipSize]="300" class="flex-shrink-0">
                    <fa-icon [icon]="faCircleInfo" class="text-gray-300"></fa-icon>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>

      <!-- Selected rules -->
      <div class="flex flex-col h-full w-1/2 gap-3 py-6 border-bic-gray-200 border rounded-lg overflow-hidden">
        <!-- Header -->
        <p class="text-gray text-sm px-6 flex-shrink-0 font-medium h-[38px]">Ausgewählte Prüfregeln:</p>

        <!-- Selected rules list with drop zone -->
        <div #selectedRulesList="cdkDropList"
             (cdkDropListDropped)="drop($event)"
             [cdkDropListConnectedTo]="availableRulesList"
             [cdkDropListData]="selectedRules"
             cdkDropList
             class="flex flex-col flex-grow min-h-0 w-full overflow-y-auto gap-3 py-1 px-6"
             id="selectedRulesList">
          @for (rule of selectedRules; track rule.id) {
            <div cdkDrag
                 class="flex flex-row shadow-full w-full rounded-lg justify-between items-center hover:cursor-grab p-4 flex-shrink-0">
              <div class="flex flex-row justify-start items-center gap-4 min-w-0">
                <button (click)="removeRuleFromSelectedRules(rule)" class="flex-shrink-0">
                  <fa-icon [icon]="faCircleXmark" class="text-yellow"></fa-icon>
                </button>
                <div class="font-medium text-gray-700 text-sm truncate">{{ rule.name }}</div>
              </div>
              <div class="flex flex-row justify-end items-center gap-4 flex-shrink-0">
                <div class="flex flex-row justify-end items-center gap-2">
                  @for (type of rule.docTypes; track type.name) {
                    <bic-badge
                      [tooltip]="type.name === 'LV' ? 'Leistungsverzeichnis' : type.name === 'IFC' ? 'Industry Foundation Classes' : type.name === 'RB' ? 'Raumbuch' : ''">
                      {{ type.name }}
                    </bic-badge>
                  }
                </div>
                <div [tooltipDirection]="'left'" [tooltipSubtext]="getRuleInfoTooltip(rule)"
                     [tooltip]="rule.name" [tooltipSize]="300" class="flex-shrink-0">
                  <fa-icon [icon]="faCircleInfo" class="text-gray-300"></fa-icon>
                </div>
              </div>
            </div>
          }

          <!-- Drop zone at bottom, inside cdkDropList -->
          @if (filterRules.length > 0) {
            <div
              class="flex-grow min-h-[138px] flex flex-col justify-center items-center bg-gray-50 border-2 border-dashed border-[#C6C9CB] rounded-lg p-6 gap-2">
              <fa-icon [icon]="faSquareDashedCirclePlus" class="text-gray-400 text-[48px]"></fa-icon>
              <div class="text-center text-sm text-gray-500">Prüfregeln per Drag & Drop auswählen</div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Navigation Button -->
    <div class="flex justify-center flex-shrink-0 px-6">
      <bic-button (click)="navigateToChoosingFiles()"
                  [disabled]="selectedRules.length == 0 || !permissionService.hasProjectPrivilege('PROJECT_CHECK_EXECUTE')"
                  tooltipDirection="top"
                  [tooltip]="selectedRules.length == 0 ? 'Bitte wählen Sie mindestens eine Prüfregel aus' : !permissionService.hasProjectPrivilege('PROJECT_CHECK_EXECUTE') ? 'Sie haben nicht die erforderlichen Berechtigungen, um mit der Prüfung fortzufahren' : undefined">
        Dateiauswahl
        <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
      </bic-button>
    </div>

</div>
